"use client" 
import { useState } from "react";
import InputText from "@/components/Atoms/inputText";
import fetch from "node-fetch";
import { getData } from "@/utils/frontend/dataOps";
import checkSignInStatus from "@/utils/frontend/checkSignInStatus";
import { TealButton } from "@/components/Atoms/Buttons/ColorButtons";
import Alert from "@/components/Atoms/Alerts/Alert";


// Used to enter password if talent profile is locked. 
// Called in /src/app/[lang]/talent/[talent]/page.js

const TalentProfileAuthCard = ({root, lang, talentUrl}) => {


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  };


     const [credentials, setCredentials] = useState('')
     const [contactDetails, setContactDetails] = useState('')
     const [loginFailed, setLoginFailed] = useState(false)
     const [success, setSuccess] = useState(false)
     const [error, setError] = useState(false)
   

     const handleSubmit = async () => {
       console.log(credentials)
       try {
        // let talent = await getData(`talents/${talentUrl}/?lang=${lang}`)
        // console.log("TALENT", talent)

        let response = await fetch(`/api/talent/${talentUrl}/?lang=${lang}&user_type=GUEST`, {
          method: 'POST', // Use uppercase for HTTP methods
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json',
          },

          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          // params: JSON.stringify(credentials)
          body: JSON.stringify(credentials) // Convert the credentials object to a JSON string
        });



        // let response = await fetch('/api/auth/signin', {
        //   method: 'POST', // Use uppercase for HTTP methods
        //   headers: {
        //     'Accept': '*/*',
        //     'Content-Type': 'application/json'
        //   },

        //   credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
        //   // params: JSON.stringify(credentials)
        //   body: JSON.stringify(credentials) // Convert the credentials object to a JSON string
        // });

        response = await response.json()
        if (response.success === false) { 
          setLoginFailed({message: lang === 'fr' ? 'Mot de passe invalide. Veuillez réessayer, ou demandez un nouveau mot de passe.' : 'Invalid Password. Please try again, or request a new password.'})
          console.log('Error Response: ', response)
        }
        else { 
          console.log('Response: ', response)
          if (response.token && response.user) { 
            document.cookie = `token=${await response.token}; path=/;`
            document.cookie = `user=${JSON.stringify(await response.user)}; path=/;`;
            window.location.reload();

          }
        }
        
        // document.cookie = `token=${await response.token}`;
        // document.cookie = `user=${JSON.stringify(await response.user)}`;
        // window.location.pathname.toLowerCase().includes("/login") ?  window.location.href = '/' : window.location.reload();
      
   
          
           
       } catch (error) {
         console.log('error', error)
         setLoginFailed({message: lang === 'fr' ? 'Mot de passe invalide. Veuillez réessayer, ou demandez un nouveau mot de passe.' : 'Invalid Password. Please try again, or request a new password.'})
       }
     }


     const postPutData = {
      user_full_name: contactDetails?.user_full_name,
      user_email_address: contactDetails?.user_email_address,
      user_company_name: contactDetails?.user_company_name,
    }

     const handleInquirySubmit = async () => {
        console.log(contactDetails)
        const formData = new FormData();

        // Append all other data to the FormData object
        formData.append("full_name", postPutData.user_full_name);
        formData.append("company_name", postPutData.user_company_name);
        formData.append("email_address", postPutData.user_email_address);
        formData.append("lang", lang);
        formData.append("parent_path", talentUrl);
        formData.append("parent_component", "PRIVATE TALENT PROFILE")

        try {
          let apiUrl = `/api/inquiry/`;
          let response = await fetch(apiUrl, {
            method: 'POST',
            credentials: 'include', // Keep this if you need cookies sent
            body: formData, // Send formData object
          });
      
          response = await response.json();
          console.log(response);
          // callback({refreshData: true});
          setSuccess({message: lang === 'fr' ? "Votre requête a été envoyée." : "Your request has been sent."})
      

           
       } catch (error) {
         console.log('error', error)
         setLoginFailed({message: lang === 'fr' ? 'Mot de passe invalide. Veuillez réessayer, ou demandez un nouveau mot de passe.' : 'Invalid Password. Please try again, or request a new password.'})
       }
     }
     
    //  const handleContactSubmit = async () => {
    //    sendMail(
    //      'ilias@talentive.com', // to
    //      'notification@talentive.com', // from
    //      'New Talent Password Request', // subject
    //      'New Talent Password Request', // text (?)
    //      `Name: ${contactDetails.user_full_name}<br/>
    //          Email Address: ${contactDetails.user_email_address}<br/>
    //          Company Name: ${contactDetails.user_company_name}
    //          Source Page Language: ${lang}<br/>
    //          Source URL Path: ${talentUrl}<br/>
    //      `
    //  )
    //   }


   return (
    // flex items-center justify-center min-h-screen
    <div className="container mx-auto">
       <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>
<div className=" grid xl:flex-row items-center min-h-screen xl:grid xl:grid-cols-12 gap-4 my-24 xl:my-0">
<div className="flex justify-center mx-2 md:mx-2 xl:col-span-4 bg-white dark:bg-slate-700 rounded-3xl p-8 shadow-xl">


    <div className="w-full max-w-sm bg-white dark:bg-inherit dark:border-gray-700 space-y-2 py-8">
    {/* <div className="flex xl:flex-row items-stretch min-h-full grid xl:grid-cols-12 gap-4 my-24 xl:my-0"> */}
      {/* <div className="w-full max-w-sm bg-white sm:p-6 dark:bg-inherit dark:border-gray-700 space-y-4 flex flex-col justify-between"> */}
      
           {/* <form className="space-y-6" onSubmit={handleSubmit} method="POST"> */}

             {/* <div className="text-2xl font-black text-indigo-600 dark:text-pink-500 font-montserrat font-black whitespace-nowrap">
               {lang === 'fr' ?<>Ce Profil est Confidentiel</> : <>This is a Private Profile</>}
             </div>
     
             <div className="text-sm font-medium text-gray-500 dark:text-gray-300">
              {lang === 'fr' ? <>Veuillez saisir le mot de passe qui vous a été fourni afin d'accéder au profil.</> : <>Please enter the password that was provided to you to access the profile.​</>}
             </div> */}

<div>
<div className="text-left font-ubuntu text-teal-400 dark:text-teal-400 text-2xl">
{lang === 'fr' ?<>Ce Profil est Confidentiel</> : <>This is a Private Profile</>}
  </div>
<div className="text-sm font-medium text-gray-500 dark:text-gray-300 text-left font-inter">
{lang === 'fr' ? <>Veuillez saisir le mot de passe qui vous a été fourni afin d'accéder au profil.</> : <>Please enter the password that was provided to you to access the profile.​</>}
             </div>

             </div>


<div className="space-y-2">
             <InputText 
             onKeyDown={handleKeyDown}
              darkBGValue={'dark:bg-slate-700'}
             data={{
               type: 'password',
               id: 'user_password',
               onChange:(x)=>{setCredentials({...credentials, user_password: x.target.value})},
               label: lang === 'fr' ? 'Votre Mot de Passe' : 'Your Password',

               value: credentials.user_password || ''
               }}/>
        
             {/* <button
               type="submit"
               onClick={handleSubmit}
               className="w-full text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800 ease-in-out duration-500"
             >
               {lang === 'fr' ? 'Accéder au Profil' : 'Access the Profile'}
             </button> */}

             <TealButton
              onClick={handleSubmit}
              caption={lang === 'fr' ? 'Accéder au Profil' : 'Access the Profile'}
              loading={false}
              border={true}
              textSize={'text-sm'}
              />
</div>

             <br/>
             <div className="flex items-start">
                    
<label
  htmlFor="remember"
  className={`ml-2 text-sm font-medium text-red-600 dark:text-gray-300 ${loginFailed ? 'block' : 'hidden'}`}
>
  {loginFailed?.message}
</label>
</div>
<br/>


             <div>
<div className={`text-left font-ubuntu text-teal-400 dark:text-teal-400 text-2xl`}>
  {lang === 'fr' ? 'Pas de Mot de Passe ?' : <>Don't have a Password?</>}
  </div>
<div className="text-sm font-medium text-gray-500 dark:text-gray-300 text-left font-inter">
              {lang === 'fr' ? <>Veuillez entrer votre nom complét, adresse courriel ainsi que le nom de votre entreprise ci-dessous pour demander un nouveau mot de passe.</> : <>Please enter your Full Name, Email Address and Company Name below to request a new password.​</>}
             </div>

             </div>


             <div className="space-y-2">
             <InputText 
            darkBGValue={'dark:bg-slate-700'} 
             data={{
               type: 'text',
               id: 'user_full_name',
               onChange:(x)=>{setContactDetails({...contactDetails, user_full_name: x.target.value})},
               label: lang === 'fr' ? 'Votre Nom Complét' : 'Your Full Name',

               value: contactDetails.user_full_name || ''
               }}/>
             <InputText 
            darkBGValue={'dark:bg-slate-700'} 
             data={{
               type: 'email',
               id: 'user_email_address',
               onChange:(x)=>{setContactDetails({...contactDetails, user_email_address: x.target.value})},
               label: lang === 'fr' ? 'Votre Adresse Courriel' : 'Your Email Address',

               value: contactDetails.user_email_address || ''
               }}/>

             <InputText 
            darkBGValue={'dark:bg-slate-700'} 
             data={{
               type: 'text',
               id: 'user_company_name',
               onChange:(x)=>{setContactDetails({...contactDetails, user_company_name: x.target.value})},
               label: lang === 'fr' ? 'Le Nom de votre Entreprise' : 'Your Company Name',

               value: contactDetails.user_company_name || ''
               }}/>
             </div>

             {/* <button
               type="submit"
               onClick={handleInquirySubmit}
               className="w-full text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800 ease-in-out duration-500"
             >
               {lang === 'fr' ? 'Demander le Mot de Passe' : 'Request Password'}
             </button> */}

             <TealButton
              onClick={handleInquirySubmit}
              caption={lang === 'fr' ? 'Demander le Mot de Passe' : 'Request Password'}
              loading={false}
              border={true}
              textSize={'text-sm'}
              />
             <div>
              

             </div>



         </div>
     </div>







     {/* style={{color: '#E91E63'}} */}

    {/* <div className="xl:col-span-8 mx-2 md:mx-2 space-y-2">
     <div className="bg-white dark:bg-slate-700 rounded-3xl p-14 shadow-xl min-h-96"> */}
     
     <div className="xl:col-span-8 mx-2 md:mx-2 space-y-2 flex flex-col justify-between">
     {/* <div className="bg-white dark:bg-slate-700 rounded-3xl p-14 shadow-xl flex-1">

     </div> */}
     <div className="rounded-3xl p-14 flex-1">
        <h1 className="text-2xl font-ubuntu text-teal-400 dark:text-teal-400 mb-1" > 
            {lang === 'fr' ? "Pourquoi ce Profil est il en Accès Confidentiel ?" : "Why is this Profile set to Private Access?"}
        </h1>
        <hr className="w-2/4 mr-auto bg-gray-200 dark:bg-gray-400 mb-4" style={{height: '4px', border: '0px'}}/>
        <div className="dark:text-gray-100 font-ubuntu">
            {lang === 'fr' ? 
            
            <>
              <h2 className="text-lg font-bold">Ce profil est réglé sur un accès privé pour l'une ou plusieurs des raisons suivantes :</h2>
              
              <span className="text-sm font-inter">
                  - Le candidat est actuellement employé et souhaite garder sa recherche d'emploi confidentielle pour ne pas compromettre son emploi actuel.<br/>
                  - Le candidat a fourni une liste spécifique d'entreprises où il est intéressé à postuler, et son profil n'est accessible qu'à ces entreprises.<br/>
                  - Le candidat préfère une approche plus personnalisée et discrète pour sa recherche d'emploi, en veillant à ce que son profil soit uniquement partagé avec des organisations qui correspondent à ses objectifs de carrière et à ses valeurs.<br/>
                  - Le profil du candidat contient des informations sensibles qu'il préfère partager uniquement avec des employeurs potentiels pré-approuvés.<br/>
                  - Le candidat postule pour un rôle de haut niveau ou exécutif, et le maintien de la confidentialité est crucial en raison de la nature du poste.<br/>
                  - Le candidat a accepté un arrangement exclusif avec le recruteur qui le représente, lui permettant de partager son profil uniquement avec des clients sélectionnés.<br/>
                  - Le candidat accorde de l'importance à sa vie privée et a demandé que son profil soit partagé uniquement avec des employeurs potentiels ayant manifesté un intérêt sérieux.<br/>
              </span>
            </>
            : 
            <>
            <h2 className="text-lg font-bold">This Candidate Profile is set to Private Access due to one or more of the following reasons:</h2>
              
              <span className="text-sm font-inter">
            - The candidate is currently employed and wishes to keep their job search confidential to avoid compromising their current employment.<br/>
            - The candidate has provided a specific list of companies where they are interested in applying, and their profile is only accessible to those companies.<br/>
            - The candidate prefers a more tailored and discreet approach to their job search, ensuring their profile is only shared with organizations that match their career goals and values.<br/>
            - The candidate’s profile contains sensitive information that they prefer to share only with pre-approved potential employers.<br/>
            - The candidate is applying for a high-level or executive role, and maintaining confidentiality is crucial due to the nature of the position.<br/>
            - The candidate has agreed to an exclusive arrangement with the recruiter, allowing the recruiter to share their profile only with select clients.<br/>
            - The candidate values their privacy and has requested that their profile be shared only with potential employers who have demonstrated serious interest.<br/>
            </span>
            </>}
        </div>
        </div>
        {/* <div className="bg-white dark:bg-slate-700 rounded-3xl p-8 shadow-xl dark:text-gray-100 font-montserrat">
<div className="space-y-2">
  <div className="flex items-center">
    <i className="fa-solid fa-phone pr-2"></i>
    <span>514 535 0137</span>
  </div>
  <div className="flex items-center">
    <i className="fa-solid fa-envelope pr-2"></i>
    <span>info@talentive.com</span>
  </div>
  <div className="flex items-center">
    <i className="fa-solid fa-location-dot pr-2"></i>
    <span>Montréal, Québec, Canada</span>
  </div>
</div>
        </div> */}

    </div>

    






    

     </div>
     </div>
   )
     
     return (
       <>
       <div className="flex items-center justify-center min-h-screen"> 
         <div className="w-full max-w-sm p-4 bg-white border border-gray-200 shadow-xl rounded-3xl shadow sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700 space-y-4">
           {/* <form className="space-y-6" onSubmit={handleSubmit} method="POST"> */}
             <h5 className="text-2xl font-black text-indigo-600 dark:text-indigo-500">
               {lang === 'fr' ?<span className="dark:text-white">Profil à Accès Confidentiel</span> : <span className="dark:text-white">Private Access Profile</span>}
             </h5>
             <br/>
             <div className="text-sm font-medium text-gray-500 dark:text-gray-300">
              {lang === 'fr' ? ' ' : <>Enter the password provided to you by an employee of <span className="text-indigo-700 dark:text-indigo-500">Talentive Inc.</span></>}
             </div>

             <div>
             <InputText data={{
               type: 'password',
               id: 'user_password',
               onChange:(x)=>{setCredentials({...credentials, user_password: x.target.value})},
               label: 'Your Password',
               darkBGValue: '800',
               value: credentials.user_password
               }}/>
             </div>
             <button
               type="submit"
               onClick={handleSubmit}
               className="w-full text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800 ease-in-out duration-500"
             >
               Access the Profile
             </button>
             <div className="text-center text-black">

<div className="inline-flex items-center justify-center w-full text-sm font-medium text-gray-500 dark:text-gray-300">
    <hr className="w-64 h-1 my-8 bg-gray-200 border-0 rounded dark:bg-gray-700"/>
    <div className="absolute px-4 -translate-x-1/2 bg-white left-1/2 dark:bg-gray-900">
    or request one 
        {/* <svg class="w-4 h-4 text-gray-700 dark:text-gray-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 14">
  </svg> */}
    </div>
</div>
             </div>


             <div>
             <InputText data={{
               type: 'email',
               id: 'user_email_address',
               onChange:(x)=>{setCredentials({...credentials, user_email_address: x.target.value})},
               label: 'Your Email Address',
               darkBGValue: '800',
               value: credentials.user_email_address
               }}/>
             </div>

             <button
               type="submit"
               onClick={handleSubmit}
               className="w-full text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800 ease-in-out duration-500"
             >
               Request Password
             </button>
             <div>
              

             </div>
             <div className="flex items-start">
               {/* <div className="flex items-start">
                 <div className="flex items-center h-5">
                   <input
                     id="remember"
                     type="checkbox"
                     value=""
                     className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-indigo-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-indigo-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800"
                     required
                   />
                 </div>
                 <label
                   for="remember"
                   className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                 >
                   Remember me
                 </label>
               </div> */}
                    <div className="flex items-start">

                 <label
                   htmlFor="remember"
                   className={`ml-2 text-sm font-medium text-red-600 dark:text-gray-300 ${loginFailed ? 'block' : 'hidden'}`}
                 >
                   {loginFailed?.message}
                 </label>
               </div>
   
    
   
             </div>

             {/* {!root && (<div className="text-sm font-medium text-gray-500 dark:text-gray-300">
               Not registered?{" "}
               <a
                 href="/app/auth/register"
                 className="text-indigo-700 hover:underline dark:text-indigo-500"
               >
                 Create an account
               </a>
             </div>)} */}
           {/* </form> */}
         </div>
         </div>
       </>
     );
   };

export default TalentProfileAuthCard